import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AnimatePresence } from '@sopranodesign/framer-motion';
import {
  Flex,
  Button,
  Accordion,
  Explainer,
  Span,
  InlineNotification,
  Label,
  TextInput
} from '@sopranodesign/pulse-components';

import FormGroup from './FormGroup';
import SettingContainer from './SettingContainer';
import { exportSubscriber } from '../../api/index';
import { isValidEmail } from '../../utilities/index';
import { useMutation, useTheme } from '../../hooks/index';
import getErrorMessage from './errors';

const RequestData = () => {
  const [email, setEmail] = useState('');

  const [showEmailError, setShowEmailError] = useState(false);

  const theme = useTheme();

  const { t } = useTranslation('bots');

  const mutation = useMutation({
    mutationFn: exportSubscriber,
    onSuccess: () => {
      setEmail('');
    }
  });

  const handleEmailChange = event => {
    setEmail(event.target.value);
  };

  const valid = Boolean(mutation.isEnabled && !mutation.isPending && email);

  const handleSubmit = event => {
    event.preventDefault();

    setShowEmailError(false);

    if (!isValidEmail(email)) {
      return setShowEmailError(true);
    }

    if (valid) {
      mutation.mutate(email);
    }
  };

  return (
    <SettingContainer>
      <Accordion divider header={t('request_data_setting_header')}>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Explainer type="note" hideLabel>
              <Span tinyText colour="black">
                {t('request_data_setting_description')}
              </Span>
            </Explainer>
            <Flex col>
              <Label htmlFor="email" colour="black">
                {t('request_data_setting_email_label')}
              </Label>
              <TextInput
                id="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="example@email.com"
              />
            </Flex>
            <AnimatePresence>
              {mutation.isError && (
                <InlineNotification
                  description={t(getErrorMessage(mutation.error))}
                  type="error"
                />
              )}
              {showEmailError && (
                <InlineNotification
                  description={t(
                    'request_data_setting_invalid_email_error_message'
                  )}
                  type="error"
                />
              )}
            </AnimatePresence>
            <AnimatePresence>
              {mutation.isSuccess && (
                <InlineNotification
                  description={t('request_data_setting_success_message')}
                  type="success"
                />
              )}
            </AnimatePresence>
            <Button
              disabled={!valid}
              icon="download"
              type="submit"
              customTextColour={theme.sentMessage?.text || 'white'}>
              {t('request_data_setting_submit_button')}
            </Button>
          </FormGroup>
        </form>
      </Accordion>
    </SettingContainer>
  );
};

export default RequestData;
